(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sd-header"] && !Shopify.designMode) return;
  try {
    
  // Native <dialog> gives Escape-to-close, the backdrop and focus trapping for
  // free. This only wires the open and close buttons, restores focus, and
  // drives the mobile search toggle.
  (function () {
    var header = document.querySelector('[data-sd-header]');
    var dialog = document.getElementById('SdMenuDialog');
    var opener = document.querySelector('[data-sd-menu-open]');

    if (dialog && opener) {
      var closer = dialog.querySelector('[data-sd-menu-close]');

      opener.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });

      if (closer) {
        closer.addEventListener('click', function () {
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        });
      }

      dialog.addEventListener('close', function () { opener.focus(); });
    }

    if (header) {
      var toggle = header.querySelector('[data-sd-search-toggle]');
      var input = header.querySelector('#SdSearchInput');

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (header.hasAttribute('data-search-open')) {
            header.removeAttribute('data-search-open');
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            header.setAttribute('data-search-open', '');
            toggle.setAttribute('aria-expanded', 'true');
            if (input) input.focus();
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.hasAttribute('data-search-open')) {
          header.removeAttribute('data-search-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.focus();
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
